<template>
	<scroll-view scroll-y class="box">
		<web-view :src="address"></web-view>
	</scroll-view>
</template>

<script>
	export default {
		data() {
			return {
				address: ''
			};
		},
		onLoad(option) {
			this.address = decodeURIComponent(option.url)
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100vw;
		height: 100vh;
		web-view {
			width: 100%;
			height: 100%;
		}
	}
</style>
